'use client';

import { CONFIG } from '@frameio/config';
import { VersionGate } from '@frameio/shared/account-migration/VersionGate';
import { ErrorBoundary } from '@frameio/shared/components/ErrorBoundary';
import { useIsIntegrationClient } from '@frameio/shared/contexts/ClientNameContext';
import { AccountLockBanner } from './AccountLockBanner';
import { AccountUpdateAlertBanner } from './AccountUpdateAlertBanner';
import { BannerContainer } from './BannerContainer';
import { NetworkStatusBanner } from './NetworkStatusBanner';
import { NetworkStatusUXPBanner } from './NetworkStatusUXPBanner';
import { PreviewEnvironmentBanner } from './PreviewEnvironmentBanner';
import { UsageAlertBanners } from './UsageAlertBanners';

export const AppAlertBanner = () => {
  const isIntegrationClient = useIsIntegrationClient();

  return (
    <ErrorBoundary fallback={null}>
      <VersionGate>
        <BannerContainer data-testid="app-alert-banner-container">
          {CONFIG.enablePreviewEnvironmentBanner && (
            <PreviewEnvironmentBanner key="previewEnvironmentBanner" />
          )}
          {isIntegrationClient ? (
            <NetworkStatusUXPBanner key="networkStatusBanner" />
          ) : (
            <NetworkStatusBanner key="networkStatusBanner" />
          )}
          <AccountUpdateAlertBanner key="accountUpdateAlertBanner" />
          <AccountLockBanner key="accountLockBanner" />
          <UsageAlertBanners key="usageAlertBanners" />
        </BannerContainer>
      </VersionGate>
    </ErrorBoundary>
  );
};
